import { runJsonGet } from '@/backend-client'
import { OPERATIONS_BACKEND_URL } from '@/config'
import { transformKeysToCamelCase } from './utils/casing'

export const fetchPartnerManagerContact = async () => {
  const { data } = await runJsonGet(`${OPERATIONS_BACKEND_URL}/ordering/sennder-contact`)
  return transformKeysToCamelCase(data)
}
